import PropTypes from "prop-types";
import { classNamePropType } from "../../common";

/**
 * PropTypes for PublicNavbar component
 * @typedef {Object} PublicNavbarProps
 * @property {string} [className] - Optional CSS class name
 * @property {('default'|'landing')} [variant] - Visual style variant for the navbar
 */
export const publicNavbarPropTypes = {
  className: classNamePropType,
  variant: PropTypes.oneOf(["default", "landing"]),
};
